import 'babel-polyfill'
// Import store
import store from './app/store'

import register from './login/register.vue'
import forgotPassword from './login/forgot-password.vue'
import confirmReset from './login/confirm-reset.vue'
import about from './login/about.vue'
import TermsAndConditions from './login/terms-and-conditions.vue'
import browser from './login/browser.vue'

window._ = require('lodash')
// Vue
window.Vue = require('vue').default
require('es6-promise').polyfill()
window.axios = require('axios')

// Include CSRF on AXIOS calls
window.axios.defaults.headers.common = {
  'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
  'X-Requested-With': 'XMLHttpRequest'
}

Vue.component('register', register)
Vue.component('forgot-password', forgotPassword)
Vue.component('about', about)
Vue.component('terms-and-conditions', TermsAndConditions)
Vue.component('browser', browser)
Vue.component('confirm-reset', confirmReset)

if (process.env.NODE_ENV === 'production') {
  window.basePath = 'app/scr'
} else {
  window.basePath = 'scr'
}

window.rootPath = process.env.MIX_API_HOST;

Vue.mixin({
  methods: {
    asset: path => window.rootPath + path
  }
})
// start bus
window.bus = new Vue()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store: store,
  data: {
    showRegisterModal: false,
    showResetPasswordModal: false,
    showAboutModal: false,
    showTermsModal: false,
    showBrowserModal: false,
  },
  methods: {
    register (state) {
      this.showRegisterModal = state
      if (state) {
        window.location.hash = 'register'
      } else {
        window.location.hash = ''
      }
    },
    callAPI (method, url, data) {
      return axios({
        url: window.rootPath + url,
        method: method,
        data: data
      })
    }
  },
  created () {
    if (window.innerWidth < 1024) {
      this.showBrowserModal = true
    }
    if (window.location.hash === '#register') {
      this.register(true)
    }
    this.$store.dispatch('fetchTermsData')
  }
})
